module.exports = __webpack_public_path__ + "img/alien.86f31579.png";